import { useQuery } from "@tanstack/react-query";

import {
  DocumentByIdDTO,
  DocumentsDTO,
  DocumentsQuery,
  getDocumentBills,
  getDocumentById,
  getDocuments,
} from "api";

import { QUERY_KEYS } from "consts";

import { useState } from "react";
import { DOCUMENTS_REFETCH_INTERVAL } from "./consts";
import { OptionalRefetchIntervalAndRetry } from "./types";

export const useDocuments: any = ({
  refetchInterval = DOCUMENTS_REFETCH_INTERVAL,
  retry = false,
  ...query
}: DocumentsQuery & OptionalRefetchIntervalAndRetry) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isLoading, setIsLoading] = useState(true);
  const { data, error, refetch } = useQuery<DocumentsDTO>(
    [QUERY_KEYS.DOCUMENTS, query],
    async () => {
      setIsLoading(true)
      try {
        const result = await getDocuments(query);
        setIsLoading(false);
        return result;
        // eslint-disable-next-line @typescript-eslint/no-shadow
      } catch (error) {
        setIsLoading(false);
        throw error;
      }
    },
    {
      refetchInterval,
      retry,
      onSuccess: () => setIsLoading(false),
      onError: () => setIsLoading(false),
    },
  );
  return { data, isLoading, error, refetch };
};

export const useDocumentById = (id: string | undefined) =>
  useQuery<DocumentByIdDTO>([QUERY_KEYS.DOCUMENTS, id], () => getDocumentById(id!), { enabled: !!id });

export const useDocumentBills = (id: string) =>
  useQuery<any>([QUERY_KEYS.DOCUMENT_BILLS, id], () => getDocumentBills(id));
